//@flow
export default class StoreDataChangeEvent<DATA_TYPE> {
  static TYPE_ADD = 'ADD';
  static TYPE_EDIT = 'EDIT';
  static TYPE_DELETE = 'DELETE';
  storeName: string;
  name: string;
  data: ?DATA_TYPE;
  type: string

  constructor(storeName: string, name: string, data: ? DATA_TYPE, type: string) {
    this.storeName = storeName;
    this.name = name;
    this.data = data;
    this.type = type;
  }

  getName(): string {
    return this.name;
  }

  getData(): ?DATA_TYPE {
    return this.data;
  }

  getType(): any {
    return this.type;
  }
}